import { render, staticRenderFns } from "./WalletMonthly.vue?vue&type=template&id=222c66ea&scoped=true"
import script from "./WalletMonthly.vue?vue&type=script&lang=js"
export * from "./WalletMonthly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222c66ea",
  null
  
)

export default component.exports